module.exports = "/assets/freebies/martini.png?Bj5G1fC";